import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M12 3c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm.9 13.5h-1.8v-1.8h1.8v1.8zm0-3.6h-1.8V7.5h1.8v5.4z"
	})
});
export default SvgError;
